/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import messages from 'src/shared/app/moderation/l10n/zmoderationL10n';
import { moderationAcceptedNotificationTimeout } from 'src/shared/app/moderation/settings/moderationSettings';
import Notification from 'src/shared/app/notification/component/Notification';

import type { Notification as NotificationType } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: NotificationType<>,
  handleDismiss: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const ModerationAcceptedNotificationDumb = (props: Props): React.Node => {
  const { handleDismiss, intl } = props;

  // Elements

  return (
    <Notification
      timeout={moderationAcceptedNotificationTimeout}
      handleDismiss={handleDismiss}
    >
      {intl.formatMessage(messages.moderationAcceptedNotification)}
    </Notification>
  );
};

export default compose(injectIntl)(ModerationAcceptedNotificationDumb);
